import { z } from 'zod';

import { type EntitlementStore } from '../entitlement-store/entitlement-store';

/**
 * The stores an in-app purchase can come from — the strict subset of
 * {@link EntitlementStore} that has an app store behind it.
 *
 * It exists because `direct` and `promo` are meaningless for anything the stores
 * own: an offer code cannot be minted for a bank transfer, and a comp has no
 * product id to map. Typing those two out of the offer-code table makes the
 * nonsense unrepresentable rather than merely unwritten, and the annotation
 * below is what fails the build if `EntitlementStore` ever renames one of them.
 */
export const IAP_STORES = ['app_store', 'play_store'] as const;

export const IapStoreSchema = z.enum(IAP_STORES);

export type IapStore = (typeof IAP_STORES)[number];

/** Compile-time proof that every IAP store is a store an entitlement can hold. */
const _IAP_STORES_ARE_ENTITLEMENT_STORES: readonly EntitlementStore[] = IAP_STORES;
void _IAP_STORES_ARE_ENTITLEMENT_STORES;

const IAP_STORE_SET: ReadonlySet<string> = new Set(IAP_STORES);

export function isIapStore(value: string): value is IapStore {
  return IAP_STORE_SET.has(value);
}
